<template>
  <svg :class="'icon'" width="19" height="18" viewBox="0 0 19 18" fill="none">
    <circle cx="15" cy="4" r="3.5" :fill="color" />
    <circle cx="4" cy="13.6299" r="3.5" :fill="color" />
    <path
      d="M4 13.625L15 4"
      :stroke="color"
      stroke-width="3"
      stroke-linecap="round"
    />
  </svg>
</template>

<script setup>
defineProps({
  color: {
    type: String,
    default: '#000000', // Set your desired default color here
  },
})
</script>

<style lang="scss" scoped></style>
